var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"watermark",rawName:"v-watermark"}],class:{'img-watermark': true, [_vm.className]: true},attrs:{"src":_vm.imageUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }